<template>
  <select class="form-control" name="template_id" id="template_id" v-model="value" @change="onChange($event)">
    <option value=''>Selecciona un template</option>
    <option v-for="template in options" :key="template.id" :value="template.id"
            :selected="selectedValue == template.id">{{ template.name }} ({{ template.description }})
    </option>
  </select>
</template>

<script>
export default {
  name: 'template-selector',
  props: {
    selectedValue: {
      type: [String, Number],
      default: '',
    },
  },
  data() {
    return {
      value: '',
      options: [],
    };
  },
  methods: {
    onChange(event) {
      this.$emit('update', event.target.value);
    },
    initTemplates() {
      fetch('https://res.hotelkey.com/reservas/mvc.php/product_decision_scr_templates_web_json/ScrTemplates/list')
        .then(response => response.json())
        .then(data => {
          if (data.result) {
            this.options = data.data;
          } else {
            this.emitError();
          }
        }).catch(() => {
        this.emitError();
      });
    },
    selectTemplate() {
      if (this.options.length > 0 && this.selectedValue != null && this.selectedValue !== '') {
        this.value = String(this.selectedValue);
      }
    },
  },
  watch: {
    selectedValue(val) {
      if (val != null && val !== '') {
        this.value = String(val);
      } else {
        this.value = '';
      }
    },
    options(newVal) {
      if (newVal.length > 0) {
        this.selectTemplate();
      }
    }
  },
  created() {
    this.initTemplates();
  },
};
</script>